const Icon = () => {
  return (
    <img src={`${AZURE_BASE_URL}/icon_google.webp`} alt="Google icon" />
  )
}

const Google = () => {
  return (
    <div className="google">
      <div className="google__icon">
        <Icon />
      </div>
      <p className="google__text">
        Continuar con Google
      </p>
    </div>
  )
}

export default Google